import {isBooleanTrue} from './Type';
export {isBooleanTrue};
